<template>
  <v-menu offset-y v-model="config.status.menu" :close-on-content-click="false">
    <template v-slot:activator="{ on }">
      <v-btn small depressed fab
        v-on="on"
        :class="$props.className || ''">
        <v-badge color="transparent">
          <v-icon size="20">fa-pen</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-list>
      <v-list-item @click="open({ type: 'post' })">
        <v-list-item-avatar>
          <v-icon small>fa-clock</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>対応履歴</v-list-item-content>
      </v-list-item>
      <v-list-item @click="open({ type: 'credit' })">
        <v-list-item-avatar>
          <v-icon small>fa-credit-card</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>会計処理</v-list-item-content>
      </v-list-item>
      <v-list-item @click="open({ type: 'transfer'})">
        <v-list-item-avatar>
          <v-icon small>fa-envelope-open-dollar</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>送金処理</v-list-item-content>
      </v-list-item>
      <v-list-item @click="open({ type: 'tutor' })">
        <v-list-item-avatar>
          <v-icon small>fa-book-reader</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>個別指導</v-list-item-content>
      </v-list-item>
    </v-list>
    <v-dialog scrollable persistent v-model="config.status.active" max-width="600">
      <PostRecorder
        v-if="config.type === 'post'"
        ref="post"
        :closer="true"
        @done="close"
        @close="close"
      />
      <TransferRecorder
        v-if="config.type === 'transfer'"
        ref="transfer"
        :closer="true"
        @done="close"
        @close="close"
      />
      <CreditRecorder
        v-else-if="config.type === 'credit'"
        ref="credit"
        :close="true"
        @done="close"
        @close="close"
      />
      <TutorRecorder
       v-else-if="config.type === 'tutor'"
        ref="tutor"
        :close="true"
        @done="close"
        @close="close"
      />
    </v-dialog>
  </v-menu>
</template>

<script>
import PostRecorder from '@/components/recorder/post'
import TransferRecorder from '@/components/recorder/transfer'
import CreditRecorder from '@/components/recorder/credit'
import TutorRecorder from '@/components/recorder/tutor'
export default {
  name: 'RecorderToolkit',
  props: [ 'className' ],
  components: {
    PostRecorder,
    TransferRecorder,
    CreditRecorder,
    TutorRecorder
  },
  data () {
    return {
      config: {
        status: {
          active: false,
          menu: false
        },
        type: 'post'
      }
    }
  },
  watch: {
    'config.status.active': function (val) {
      if (!val) {
        this.$set(this.config.status, 'menu', false)
      }
    }
  },
  methods: {
    open: function (req) {
      const { type } = req || {}
      this.$set(this.config, 'type', type)
      this.$nextTick(() => {
        this.$set(this.config.status, 'active', true)
        this.$nextTick(() => {
          this.$refs[this.config.type].init()
        })
      })
    },
    close: function () {
      this.$set(this.config.status, 'active', false)
    }
  },
  computed: {
    printClassName () {
      return this.$props.className || ''
    }
  }
}
</script>